import { Connection } from '@/rtk-query.gql';
import { getLocalStorage, setLocalStorage } from '@/utils/storage';

export enum ConnectionsActions {
  UPDATE_CONNECTIONS = 'connections/UPDATE_AVAILABLE_CONNECTIONSS',
  UPDATE_CURRENT_CONNECTION = 'connections/UPDATE_CURRENT_CONNECTION',
  UPDATE_CURRENT_CONNECTIONS = 'connections/UPDATE_CURRENT_CONNECTIONS',
  UPDATE_REGIONS = 'region/UPDATE_AVAILABLE_REGIONS',
  UPDATE_CURRENT_REGION = 'region/UPDATE_CURRENT_REGION',
}

export type RegionType = Omit<
  Connection,
  | '__typename'
  | 'connectionStringKey'
  | 'connectionType'
  | 'overrideEnvironmentId'
  | 'crmUrl'
>;

export type ConnectionsWithOmits = Omit<
  Connection,
  '__typename' | 'connectionStringKey'
>;

export type ConnectionsType = {
  allConnections: ConnectionsWithOmits[] | null;
  currentConnection: ConnectionsWithOmits;
  allRegions: RegionType[] | null;
  currentRegion: RegionType;
};

export const initialState: ConnectionsType = {
  allConnections: null,
  currentConnection: {
    connectionType: 'Production',
    countryName: 'USA',
    countryCode: 'US',
    languageCode: 'en',
    crmUrl: '',
    overrideEnvironmentId: 0,
  },
  allRegions: null,
  currentRegion: {
    countryName: getLocalStorage('region')?.countryName || 'United States',
    countryCode: getLocalStorage('region')?.countryCode || 'US',
    languageCode: getLocalStorage('region')?.languageCode || 'en',
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case ConnectionsActions.UPDATE_CONNECTIONS: {
      return {
        ...state,
        allConnections: action.allConnections,
        currentConnection: action.currentConnection,
        allRegions: action.allRegions,
        currentRegion: getLocalStorage('region') || action.currentRegion,
      };
    }
    case ConnectionsActions.UPDATE_CURRENT_CONNECTION: {
      return {
        ...state,
        currentConnection: action.currentConnection,
      };
    }
    case ConnectionsActions.UPDATE_CURRENT_REGION: {
      setLocalStorage('region', action.currentRegion);
      return {
        ...state,
        currentRegion: action.currentRegion,
      };
    }
    default:
      return state;
  }
}
